import { nanoid } from "nanoid";
import constants from "../../../constants.js";
import {
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import React, { useContext, useEffect, useMemo } from "react";
import AlertContext from "../../../context/AlertContext.js";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate.js";
import { getDataFromStorage, emailBody } from "../../../util.js";
import Loading from "../../Notification-Loading/Loading/Loading.js";
import {
  Link,
  Outlet,
  useLocation,
  useParams,
  useNavigate,
} from "react-router-dom";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks.js";
// import useDropdownMenu from "../../../Hooks/useDropDown.js";
import AdminDropDown from "../../CommonComponents/AdminDropDown.js";

// Nested Dropdown Menu Component
// const NestedDropdownMenu = ({
//   trigger,
//   children,
//   placement = "right-start",
// }) => {
//   const { anchor, anchorRef, handleOpen, handleClose, isOpen, handleToggle } =
//     useDropdownMenu();

//   return (
//     <div onMouseEnter={handleOpen} onMouseLeave={handleClose}>
//       <MenuItem
//         ref={anchorRef}
//         onClick={(e) => {
//           e.stopPropagation();
//           handleToggle(e);
//         }}
//         onMouseEnter={handleOpen}
//         sx={{ justifyContent: "space-between" }}
//       >
//         <ListItemText>Reports</ListItemText>
//         <ListItemIcon sx={{ minWidth: "unset", ml: 1 }}>
//           <svg
//             width="12"
//             height="12"
//             viewBox="0 0 12 12"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M4.5 9L7.5 6L4.5 3"
//               stroke="#667085"
//               strokeWidth="1.4"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg>
//         </ListItemIcon>
//       </MenuItem>
//       <Popper
//         open={isOpen}
//         anchorEl={anchor}
//         role={undefined}
//         transition
//         disablePortal
//         placement={placement}
//         sx={{ zIndex: 4 }}
//       >
//         {({ TransitionProps }) => (
//           <Grow {...TransitionProps}>
//             <Paper>
//               <ClickAwayListener onClickAway={handleClose}>
//                 <MenuList>{children}</MenuList>
//               </ClickAwayListener>
//             </Paper>
//           </Grow>
//         )}
//       </Popper>
//     </div>
//   );
// };

const Batch = () => {
  const {
    lpId,
    setMid,
    setQns,
    setLpId,
    setLpcid,
    setLStatus,
    setLibtype,
    setLpData2,
    isLoaded,
    setIsLoaded,
    setShowNotify,
    setSearchText,
    setIsFromBatch,
    setReportTopics,
    setReportStatus,
    viewLearnerData,
    batchDetails,
    setBatchDetails,
    selectedColumns,
    setIsAddLpModule,
    setIsOldLpDetail,
    setIsReportClick,
    setSelectedStatus,
    setModuleExpandKey,
    setReportSortState,
    setTypesAndModules,
    setHiddenColumnsInTable,
  } = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();

  const Others = [
    { label: "Event", name: "Event" },
    { label: "Support Requests", name: "Support Requests" },
    { label: "Calendar", name: "Calendar" },
    { label: "Announcement Poster", name: "Announcement" },
  ];

  // Memoized values for performance
  const batchRoutes = useMemo(
    () => [
      `/batches/${id}/event`,
      `/batches/${id}/issue`,
      `/batches/${id}/timeline`,
      `/batches/${id}/announcementposter`,
    ],
    [id],
  );

  const isBatchRelatedRoute = useMemo(
    () =>
      batchRoutes.some(
        (route) =>
          pathname.includes(route) && pathname.startsWith(`/batches/${id}/`),
      ),
    [batchRoutes, pathname, id],
  );

  const userRole = useMemo(() => getDataFromStorage("role"), []);
  const isHrOrTutor = useMemo(
    () =>
      userRole === constants.Roles.hr ||
      userRole === constants.Roles.tutor ||
      userRole === constants.Roles.evaluator,
    [userRole],
  );

  useEffect(() => {
    const handleBeforeUnload = () => {
      const aLpId = sessionStorage.getItem("aLpId");
      if (aLpId) {
        sessionStorage.setItem("rLpId", aLpId);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    const fetchBatchData = async () => {
      try {
        const response = await axios.get(`node/admin/batch/${id}`, {
          headers: { "Content-type": "application/json" },
        });

        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          const batchDetail = JSON.parse(response.data.data[0].data);
          console.log("BatchDetails : ", batchDetail.batchtype);
          sessionStorage.setItem("batchType", batchDetail.batchtype);
          localStorage.setItem("batchType", batchDetail.batchtype);
          let batchType = sessionStorage.getItem("batchType");
          console.log(batchType);
          batchDetail.emailBody = emailBody;
          batchDetail.tags =
            batchDetail.tags?.split(",").map((tag) => parseInt(tag)) || [];

          if (batchDetail.learningpath) {
            batchDetail.learningpath = batchDetail.learningpath
              .filter((lp) => lp.lpid !== null)
              .map((lp) => ({ ...lp, coursename: lp.lpname }));
          }

          sessionStorage.setItem("abatchid", id);
          setBatchDetails(batchDetail);

          if (
            sessionStorage.getItem("rLpId") &&
            !sessionStorage.getItem("pathname")
          ) {
            setIsFromBatch(true);
            setIsOldLpDetail(true);
            handleGetLpApi(sessionStorage.getItem("rLpId"));
          }
        } else {
          setShowNotify({
            show: true,
            title: "Error!",
            msg: "Something went wrong. Please try again later.",
          });
        }
      } catch (error) {
        useCommonFunctionHks.getCatchBlockDetails(error);
      }
    };

    fetchBatchData();
  }, [
    id,
    axios,
    setShowNotify,
    setBatchDetails,
    setIsLoaded,
    setIsFromBatch,
    setIsOldLpDetail,
  ]);

  const handleClickDropDownMenu = (from) => {
    if (from === "Event") {
      handleNavigation("event");
    } else if (from === "Support Requests") {
      handleNavigation("issue");
    } else if (from === "Calendar") {
      handleNavigation("timeline");
    } else if (from === "Announcement") {
      handleNavigation("announcementposter");
    }
  };

  // const handleParentModule = async (data) => {
  //   setIsLoaded(true);
  //   sessionStorage.removeItem("rLpId");
  //   sessionStorage.setItem("aLpId", data.lpId);
  //   sessionStorage.removeItem("pathname");

  //   try {
  //     const res = await axios.get(
  //       `node/admin/learningpath/${data.lpId}/module/${data.modId}`,
  //       useCommonFunctionHks.getHeaderDetailsForAxios()
  //     );

  //     const newDetails = res.data.data[0];
  //     let uniqueId = 1;

  //     newDetails.modules.sort((a, b) => a.moduleorderno - b.moduleorderno);

  //     for (let i = 0; i < newDetails.modules.length; i++) {
  //       newDetails.modules[i] = {
  //         ...newDetails.modules[i],
  //         id: uniqueId,
  //         key: nanoid(),
  //         isAddTest: false,
  //         status: "old",
  //       };
  //       uniqueId++;

  //       for (let j = 0; j < newDetails.modules[i].moduleData.length; j++) {
  //         newDetails.modules[i].moduleData[j] = {
  //           ...newDetails.modules[i].moduleData[j],
  //           moduleDataId: uniqueId,
  //           key: nanoid(),
  //           status: "old",
  //           testStatus: "old",
  //           title: newDetails.modules[i].moduleData[j].testName,
  //         };
  //         delete newDetails.modules[i].moduleData[j].testName;
  //         uniqueId++;
  //       }
  //     }

  //     setIsFromBatch(true);
  //     setIsOldLpDetail(true);
  //     setIsAddLpModule(true);
  //     setModuleExpandKey([newDetails.modules[0].key]);

  //     setLpData2((prev) => ({
  //       ...prev,
  //       modules: newDetails.modules,
  //       moduleSelect:
  //         prev.parentModules?.map(({ id, name }) => ({
  //           value: id,
  //           label: name,
  //           modulemaxorderno: newDetails.modulemaxorderno,
  //         })) || [],
  //       selectedModule: prev.parentModules?.[prev.cMId]
  //         ? {
  //             value: prev.parentModules[prev.cMId].id,
  //             label: prev.parentModules[prev.cMId].name,
  //           }
  //         : null,
  //     }));

  //     navigate(`/batches/${id}/courses`);
  //   } catch (error) {
  //     useCommonFunctionHks.getCatchBlockDetails(error);
  //   } finally {
  //     setIsLoaded(false);
  //   }
  // };

  const handleLearningPath = async (lpId) => {
    navigate(`/batches/${id}/courses/${lpId}`);
    // try {
    //   const res = await axios.get(
    //     `node/admin/learningpath/${lpId}?moddata=false`,
    //     useCommonFunctionHks.getHeaderDetailsForAxios()
    //   );

    //   const data = res.data.data[0];
    //   const parentModules = data.modules
    //     .map(({ moduleId, moduleDesc, moduleName, max_orderno, ...rest }) => ({
    //       ...rest,
    //       id: moduleId,
    //       name: moduleName,
    //       description: moduleDesc,
    //       maxmodorderno: max_orderno,
    //     }))
    //     .sort((a, b) => a.moduleorderno - b.moduleorderno);

    //   const processedData = {
    //     cMId: 0,
    //     ...data,
    //     type: data.modules.length > 1 ? 2 : 1,
    //     parentModules,
    //   };

    //   delete processedData.modules;

    //   setLpData2((prev) => ({ ...prev, ...processedData }));
    //   delete Alert.lpData2.data;

    //   handleParentModule({
    //     lpId: processedData.lpId,
    //     modId: processedData.parentModules[processedData.cMId].id,
    //   });
    // } catch (err) {
    //   useCommonFunctionHks.getCatchBlockDetails(err);
    // }
  };

  const handleGetLpApi = async (lpid) => {
    if (!lpid) {
      setShowNotify({
        show: true,
        title: "Warning!",
        msg: "There is no course assigned to this batch.",
      });
      return;
    }

    // setIsLoaded(true);
    try {
      await handleLearningPath(lpid);
    } catch (error) {
      if (error.message.includes("403")) {
        setShowNotify({
          show: true,
          isUnAuth: true,
          title: "Warning!",
          msg: "You have been logged-out due to inactivity. Login again.",
        });
      } else {
        setShowNotify({
          show: true,
          title: "Error!",
          msg: "Something went wrong. Please try again later.",
        });
      }
    } finally {
      // setIsLoaded(false);
    }
  };

  const handleNavigation = (path) => {
    sessionStorage.setItem("pathname", path);
    navigate(`/batches/${id}/${path}`);
  };

  const handleReport = (lp, from) => {
    sessionStorage.setItem("aPathId", lp.lpid);
    sessionStorage.setItem("aPathName", lp.lpname);
    sessionStorage.setItem("reportBatchName", batchDetails.name);
    setIsReportClick(true);

    if (lpId !== lp.lpid) {
      // Reset report state
      const initialReportState = {
        reportSortState: [],
        searchText: "",
        hiddenColumnsInTable: [],
        reportTopics: [],
        reportStatus: [
          {
            checked: false,
            disabled: false,
            label: "Yet To Start",
            value: constants.PROGRESS_STATUS.LOCKED,
          },
          {
            checked: false,
            disabled: false,
            label: "Submitted",
            value: constants.PROGRESS_STATUS.TO_BE_EVALUATED,
          },
          {
            checked: false,
            disabled: false,
            label: "In Progress",
            value: constants.PROGRESS_STATUS.UNLOCKED,
          },
          {
            checked: false,
            disabled: false,
            label: "Resubmission",
            value: constants.PROGRESS_STATUS.REATTEMPT,
          },
          {
            checked: false,
            disabled: false,
            label: "Graded",
            value: constants.PROGRESS_STATUS.EVALUATED,
          },
        ],
        typesAndModules: [
          {
            value: "assignment",
            checked: false,
            disabled: false,
            label: "Assignment",
          },
          { value: "ccq", checked: false, label: "Coding", disabled: false },
          {
            value: "descriptive",
            checked: false,
            disabled: false,
            label: "descriptive",
          },
          { label: "MCQ", value: "mcq", checked: false, disabled: false },
          {
            label: "SQL",
            value: "sql",
            checked: false,
            disabled: false,
          },
          {
            checked: false,
            disabled: false,
            label: "Inactive",
            value: "inactive",
          },
          {
            checked: false,
            disabled: false,
            label: "Practice",
            value: "practice",
          },
        ],
      };

      setLpId(lp.lpid);
      setReportSortState(initialReportState.reportSortState);
      setSearchText(initialReportState.searchText);
      setHiddenColumnsInTable(initialReportState.hiddenColumnsInTable);
      setReportTopics(initialReportState.reportTopics);
      setReportStatus(initialReportState.reportStatus);
      setTypesAndModules(initialReportState.typesAndModules);

      viewLearnerData.current = [];
      selectedColumns.current = [];
      sessionStorage.setItem("bdNestContainer", 0);
      sessionStorage.setItem("admin-reports-table-div", 0);
    }

    // Clear other states
    setMid("");
    setQns("");
    setLpcid("");
    setLStatus("");
    setLibtype(null);
    setSelectedStatus(null);

    sessionStorage.setItem("pathname", "report");
    navigate(
      from === "old"
        ? `/batches/${id}/report`
        : `/batches/${id}/path/${lp.lpid}/report`,
    );
  };

  // Learning dropdown trigger
  const learningTrigger = (
    <p
      id="bdNavLinkLearning"
      className={`bdNavLink bdNavP ${
        pathname === `/batches/${id}/courses` ? "bdNavactive" : ""
      }`}
      style={{ cursor: "pointer" }}
    >
      Curriculum
      <ArrowDropDown fontSize="1rem" />
    </p>
  );

  // Report dropdown trigger
  const reportTrigger = (
    <p
      className={`bdNavLink bdNavP ${
        pathname.includes("/report") ? "bdNavactive" : ""
      }`}
      style={{ cursor: "pointer" }}
    >
      Report
      <ArrowDropDown fontSize="1rem" />
    </p>
  );

  // Others dropdown trigger
  const othersTrigger = (
    <p
      className={`bdNavLink bdNavP ${isBatchRelatedRoute ? "bdNavactive" : ""}`}
      style={{ cursor: "pointer" }}
    >
      Others
      <ArrowDropDown fontSize="1rem" />
    </p>
  );

  // Determine content container style
  const contentContainerStyle = useMemo(() => {
    if (pathname === `/batches/${id}/courses`) {
      return {
        overflow: "auto",
        overflowX: "hidden",
        paddingTop: "18px",
        height: "calc(100vh - 131px)",
        position: "relative",
      };
    } else if (pathname === `/batches/${id}/users`) {
      return {
        overflowY: "auto",
        height: "calc(100vh - 16.2vh)",
        paddingTop: "7px",
        position: "relative",
      };
    } else if (pathname === `/batches/${id}/dashboard`) {
      return {
        overflowY: "auto",
        height: "calc(100vh - 13.8vh)",
        paddingTop: "0px",
        position: "relative",
      };
    } else if (pathname.includes("settings")) {
      return {
        padding: 0,
        height: "calc(100vh - 16.2vh)",
        position: "relative",
      };
    } else if (pathname.includes("performance")) {
      return {
        overflow: "auto",
        height: "calc(100vh - 13.8vh)",
        overflowX: "hidden",
        position: "relative",
      };
    } else if (pathname.includes("announcementposter")) {
      return {
        padding: 0,
        height: "calc(100vh - 13.7vh)",
        position: "relative",
      };
    } else {
      return {
        overflow: "auto",
        paddingTop: "18px",
        height: "calc(100vh - 16.2vh)",
        position: "relative",
      };
    }
  }, [pathname, id]);

  const renderRow = (item) => {
    return <>{item.value}</>;
  };

  return (
    <div className="bdBatchDetailSec">
      <div className="bdNavBarSec">
        <ul className="bdNavBar">
          {Number(localStorage.getItem("university_type")) !=
            constants.ACCOUNT_TYPE.CORPORATE && (
            <li className="bdNav">
              <Link
                id="bdNavLinkSummary"
                to={`/batches/${id}/performance`}
                className={`bdNavLink ${
                  pathname.includes(`/batches/${id}/performance`)
                    ? "bdNavactive"
                    : ""
                }`}
                onClick={() =>
                  sessionStorage.setItem("pathname", "performance")
                }
              >
                Dashboard
              </Link>
            </li>
          )}

          <li className="bdNav">
            <Link
              id="bdNavLink"
              to={`/batches/${id}/dashboard?scope-ar=${
                constants.BATCH_TYPE.TESTING ===
                Number(localStorage.getItem("batchType"))
                  ? "leaderboard"
                  : "attendance"
              }`}
              className={`bdNavLink ${
                pathname === `/batches/${id}/dashboard` ? "bdNavactive" : ""
              }`}
              onClick={() => handleNavigation("dashboard")}
            >
              Reports
            </Link>
          </li>
          <li className="bdNav">
            {batchDetails?.learningpath?.length > 0 &&
            batchDetails.learningpath[0]?.lpid !== null ? (
              // <DropdownMenu
              //   id="Reports"
              //   openDropdown={openDropdown}
              //   setOpenDropdown={setOpenDropdown}
              //   trigger={reportTrigger}
              //   onClickAway={reportMenu.handleClose}
              //   onBlur={reportMenu.handleClose}
              // >
              //   {batchDetails.learningpath.map(
              //     (lp) =>
              //       lp.lpid &&
              //       lp.lpname && (
              //         <MenuItem
              //           key={lp.lpid}
              //           className="bdCourseLink"
              //           onClick={() => {
              //             setOpenDropdown(null);
              //             handleReport(lp, "new");
              //           }}
              //         >
              //           {lp.lpname}
              //         </MenuItem>
              //       )
              //   )}
              //   <Divider />
              //   <NestedDropdownMenu>
              //     {batchDetails.learningpath.map(
              //       (lp) =>
              //         lp.lpid &&
              //         lp.lpname && (
              //           <MenuItem
              //             key={lp.lpid}
              //             className="bdCourseLink"
              //             onClick={() => {
              //               setOpenDropdown(null);
              //               handleReport(lp, "old");
              //               reportMenu.handleClose();
              //             }}
              //           >
              //             {lp.lpname}
              //           </MenuItem>
              //         )
              //     )}
              //   </NestedDropdownMenu>
              // </DropdownMenu>
              batchDetails?.learningpath?.length > 1 ? (
                <div
                  className={`reports ${
                    pathname.includes(`/batches/${id}/path/${lpId}/report`)
                      ? "bdNavactive"
                      : ""
                  }`}
                >
                  Assignments
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="#101828"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="reportsdropdown">
                    {batchDetails?.learningpath.map(
                      (lp) =>
                        lp.lpid &&
                        lp.lpname && (
                          <AdminDropDown
                            item={{ label: lp.lpid, value: lp.lpname }}
                            key={lp.lpid}
                            renderRow={renderRow}
                            onSelect={(item) => handleReport(lp, "new")}
                          />
                        ),
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className={`reports ${
                    pathname.includes(`/batches/${id}/path/${lpId}/report`)
                      ? "bdNavactive"
                      : ""
                  }`}
                  onClick={() =>
                    handleReport(batchDetails?.learningpath?.[0], "new")
                  }
                >
                  Assignments
                </div>
              )
            ) : (
              <span
                className={`bdNavLink bdNavP ${
                  pathname.includes(`/batches/${id}/path/${lpId}/report`)
                    ? "bdNavactive"
                    : ""
                }`}
                onClick={() =>
                  setShowNotify({
                    show: true,
                    title: "Warning!",
                    msg: "There is no course assigned to this batch",
                  })
                }
                style={{ cursor: "pointer" }}
              >
                Assignment
              </span>
            )}
          </li>

          {userRole !== constants.Roles.evaluator && (
            <li className="bdNav">
              <Link
                id="bdNavLink"
                to={`/batches/${id}/users`}
                className={`bdNavLink ${
                  pathname === `/batches/${id}/users` ? "bdNavactive" : ""
                }`}
                onClick={() => handleNavigation("users")}
              >
                Learners
              </Link>
            </li>
          )}
          {!isHrOrTutor && (
            <li className="bdNav">
              {batchDetails?.learningpath?.length > 1 ? (
                // <DropdownMenu
                //   id="Learning"
                //   openDropdown={openDropdown}
                //   setOpenDropdown={setOpenDropdown}
                //   trigger={learningTrigger}
                //   onClickAway={learningMenu.handleClose}
                //   onBlur={learningMenu.handleClose}
                // >
                //   {batchDetails.learningpath.map(
                //     (lp) =>
                //       lp.lpid &&
                //       lp.lpname && (
                //         <MenuItem
                //           key={lp.lpid}
                //           onClick={() => {
                //             setOpenDropdown(null);
                //             handleGetLpApi(lp.lpid, lp.lpname);
                //           }}
                //           className="bdCourseLink"
                //         >
                //           {lp.lpname}
                //         </MenuItem>
                //       )
                //   )}
                // </DropdownMenu>
                <div
                  className={`curriculum ${
                    pathname.includes(`/batches/${id}/courses`)
                      ? "bdNavactive"
                      : ""
                  }`}
                >
                  Curriculum
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="#101828"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="curriculumdropdown">
                    {batchDetails?.learningpath.map(
                      (lp) =>
                        lp.lpid &&
                        lp.lpname && (
                          <AdminDropDown
                            key={lp.lpid}
                            item={{ label: lp.lpid, value: lp.lpname }}
                            onSelect={(item) =>
                              handleGetLpApi(item.label, item.value)
                            }
                          />
                        ),
                    )}
                  </div>
                </div>
              ) : (
                <p
                  id="bdNavLink"
                  className={`bdNavLink bdNavP ${
                    pathname.includes(`/batches/${id}/courses`)
                      ? "bdNavactive"
                      : ""
                  }`}
                  onClick={() =>
                    handleGetLpApi(
                      batchDetails?.learningpath[0]?.lpid,
                      batchDetails.learningpath[0]?.lpname,
                    )
                  }
                >
                  Curriculum
                </p>
              )}
            </li>
          )}

          {!isHrOrTutor && (
            <li className="bdNav">
              <Link
                id="bdNavLink"
                to={`/batches/${id}/settings/details`}
                className={`bdNavLink ${
                  pathname.includes(`/batches/${id}/settings`)
                    ? "bdNavactive"
                    : ""
                }`}
                onClick={() => handleNavigation("settings")}
              >
                Settings
              </Link>
            </li>
          )}

          {!isHrOrTutor &&
            batchDetails?.batchtype !== constants.BATCH_TYPE.TESTING && (
              <li className="bdNav">
                <div
                  className={`reports ${
                    pathname.includes("/event") ||
                    pathname.includes("/issue") ||
                    pathname.includes("/timeline") ||
                    pathname.includes("/announcementposter")
                      ? "bdNavactive"
                      : ""
                  }`}
                >
                  Others
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="#101828"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="reportsdropdown">
                    {/* {Others.map((other) => (
                      <AdminDropDown
                        key={other.label}
                        item={{ label: other.label, value: other.name }}
                        onSelect={(item) => handleClickDropDownMenu(item.value)}
                      />
                    ))} */}
                    {Others.map(
                      (other) =>
                        (other.name !== "Calendar" ||
                          Number(localStorage.getItem("university_type")) !==
                            constants.ACCOUNT_TYPE.CORPORATE) && (
                          <AdminDropDown
                            key={other.label}
                            item={{ label: other.label, value: other.name }}
                            onSelect={(item) =>
                              handleClickDropDownMenu(item.value)
                            }
                          />
                        ),
                    )}
                    {/* <>
                    <div className="typeDiv">
                      <NestedDropdownMenu
                        id="Reports"
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        trigger={reportTrigger}
                        onClickAway={reportMenu.handleClose}
                        onBlur={reportMenu.handleClose}
                        // onMouseLeave={reportMenu.handleClose}
                      >
                        {batchDetails?.learningpath?.map(
                          (lp) =>
                            lp.lpid &&
                            lp.lpname && (
                              <MenuItem
                                key={lp.lpid}
                                className="bdCourseLink"
                                onClick={() => {
                                  setOpenDropdown(null);
                                  handleReport(lp, "old");
                                  reportMenu.handleClose();
                                }}
                              >
                                {lp.lpname}
                              </MenuItem>
                            )
                        )}
                      </NestedDropdownMenu>
                    </div>
                  </> */}
                  </div>
                </div>
              </li>
            )}
        </ul>
      </div>
      <div style={contentContainerStyle}>
        <Outlet />
      </div>
    </div>
  );
};

export default Batch;
